import {defineMessages} from 'react-intl';

export const messages = defineMessages({
    LEFT: {
        id: 'techDoc.steeringWheel.option.left',
        defaultMessage: 'Left'
    },
    RIGHT: {
        id: 'techDoc.steeringWheel.option.right',
        defaultMessage: 'Right'
    },
    OTHER: {
        id: 'techDoc.steeringWheel.option.other',
        defaultMessage: 'Other'
    },
});

export default messages;
